import { render, staticRenderFns } from "./OutLink.vue?vue&type=template&id=485d278a&scoped=true"
import script from "./OutLink.vue?vue&type=script&lang=js"
export * from "./OutLink.vue?vue&type=script&lang=js"
import style0 from "./OutLink.vue?vue&type=style&index=0&id=485d278a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "485d278a",
  null
  
)

export default component.exports